import {getUserObject, assortments} from "utils/relewise";

function getCompleteTheLookObject(options: { crossStoreProductId: any; variantId: any; vendor: any; variantNames: string[]; }) {
  return {
    ProductAndVariantId: {
      ProductId: options.crossStoreProductId,
      VariantId: options.variantId,
    },
    Settings: {
      NumberOfRecommendations: 10,
      AllowFillIfNecessaryToReachNumberOfRecommendations: true,
      AllowReplacingOfRecentlyShownRecommendations: false,
      RecommendVariant: true,
      selectedProductProperties: {
        DisplayName: true,
        Pricing: true,
      },
      selectedVariantProperties: {
        DisplayName: true,
        Pricing: true,
        DataKeys: [
          "COM_ShopifyHandle",
          "DE_ShopifyHandle",
          "DK_ShopifyHandle",
          "SE_ShopifyHandle",
          "ImageUrls",
        ],
      },
    },
    Language: {
      Value: window.mosmosh.shop_local.iso,
    },
    User: getUserObject(),
    Filters: {
      Items: [
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductDataFilter, Relewise.Client",
          Key: "Vendor",
          FilterOutIfKeyIsNotFound: true,
          MustMatchAllConditions: true,
          Conditions: {
            Items: [
              {
                $type:
                    "Relewise.Client.Requests.Conditions.EqualsCondition, Relewise.Client",
                Value: {
                  Value: options.vendor,
                },
                TypeName: "EqualsCondition",
              },
            ],
          },
          TypeName: "ProductDataFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "ProductAssortmentFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.VariantAssortmentFilter, Relewise.Client",
          Assortments: [assortments[window.mosmosh.shop_code]],
          TypeName: "VariantAssortmentFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.ProductIdFilter, Relewise.Client",
          ProductIds: options.variantNames.map((variantName) =>
              variantName.substring(0, 6)
          ),
          TypeName: "ProductIdFilter",
        },
        {
          $type:
              "Relewise.Client.Requests.Filters.VariantDataFilter, Relewise.Client",
          Key: "ShopTheLook",
          FilterOutIfKeyIsNotFound: true,
          MustMatchAllConditions: true,
          Conditions: {
            Items: [
              {
                $type:
                    "Relewise.Client.Requests.Conditions.ContainsCondition, Relewise.Client",
                Value: {
                  Type: "StringList",
                  Value: {
                    $type:
                        "System.Collections.Generic.List`1[[System.String, System.Private.CoreLib]], System.Private.CoreLib",
                    $values: options.variantNames,
                  },
                },
                ValueCollectionEvaluationMode: "Any",
                TypeName: "ContainsCondition",
              },
            ],
          },
          TypeName: "VariantDataFilter",
        },
      ],
    },
    DisplayedAtLocationType: "Product detail page - Complete the look",
  };
}

export default getCompleteTheLookObject
